<iframe
  #apiDocFrame
  src="assets/docapi/redoc.html"
  width="100%"
  height="1000px"
  frameborder="0"
  style="border: none;"
></iframe>
